import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import {
    TableContentWithoutEdit
} from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { FactoryRouteWeighReportSchemaObject } from "../factoryRouteWeighReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import {
    TableContentForFactoryRouteWeighReport,
    TableContentForSumLeafCollectionVarianceReport
} from "../../../Common/Table/tableContent";
import { useExcelDownloder } from 'react-xls';
import ReactExport from "react-export-excel";
import Chip from '@material-ui/core/Chip';
import LineWeightIcon from '@material-ui/icons/LineWeight';
import ReactHTMLTableToExcel from "react-html-table-to-excel";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const screenCode = "FALCONPRODUCTCOLLECTIONREPORT";

export function FalconReport(props) {

    const componentRef = useRef();
    const [reportData, setReportData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        date: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(FactoryRouteWeighReportSchemaObject).options({ allowUnknown: true });



    const [contentRowNames, setContentRowNames] = useState(["cardNumber", "customerName", "collectionPointCode", "collectionPointName", "suppliedQty", "cardReadTime"]);

    const initialCsvHeaders = [
        { label: "Registration Number", value: "cardNumber" },
        { label: "Customer Name", value: "customerName" },
        { label: "Route Code", value: "collectionPointCode" },
        { label: "Route Name", value: "collectionPointName" },
        { label: "Supplied Quantity", value: "suppliedQty" },
        { label: "Date", value: "cardReadTime" }
    ]
    const [csvHeaders, setCsvHeaders] = useState(initialCsvHeaders);
    const [csvData, setCsvData] = useState([]);
    const { ExcelDownloder, Type, e } = useExcelDownloder();
    const [totalNet, setTotalNet] = useState({
        total:0
    }); 
    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionVariance.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            date: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryRouteWeighReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFALCONPRODUCTCOLLECTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(false);

        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        var res = await services.getFalconReportData(leafCollectionVariance);
        var total = 0;
        res.forEach(x => {
            total = total + x.suppliedQty;
            x.cardNumber = x.cardNumber
            x.cardReadTime = x.cardReadTime.split('T')[0];
            x.cardNumber = x.cardNumber;
            x.collectionPointName = x.collectionPointName;
            x.customerName = x.customerName;
            x.suppliedQty = x.suppliedQty;
        })
        setTotalNet({
            total:total
        })
        if (res != null || res.length != 0) {
            setReportData(res);
            setCsvData(res);
        }


    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { filedDate: "Total" }

        newRecord.fieldNumberOfUnits = totalRowResult.bagCount;
        totalRowResult.forEach(x => {
            newRecord[x.name] = x.value === undefined ? (0).toFixed(2) : x.value.toFixed(2);
        });

        copyOfData.push(newRecord);
        setCsvData(copyOfData);
    }





    function createFile() {
        var settings = {
            sheetName: (routes[leafCollectionVariance.routeID] === undefined ? "All Routes" + ' ' + leafCollectionVariance.date : routes[leafCollectionVariance.routeID] + ' ' + leafCollectionVariance.date),
            fileName: (routes[leafCollectionVariance.routeID] === undefined ? "All Routes" + ' ' + leafCollectionVariance.date : routes[leafCollectionVariance.routeID] + ' ' + leafCollectionVariance.date),
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            date: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Falcon Product Collection Download Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionVariance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionVariance.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionVariance.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <Chip
                                        icon={<LineWeightIcon />}
                                        label={"Total Net : " + totalNet.total}
                                        color="secondary"
                                        variant="outlined"
                                    />
                                    <br />
                                    <br />
                                    <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">
                                            <table id="adavancedRequestStatusReport" className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Registration Number</th>
                                                        <th>Supplier Name</th>
                                                        <th>Route Code</th>
                                                        <th>Route Name</th>
                                                        <th>Supplied Quantity </th>
                                                        <th>Date </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentWithoutEdit
                                                        data={reportData}
                                                        contentRowNames={contentRowNames}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                    <div className="pt-4">
                                        
                                    
                                        <table id="table-to-xls" hidden={true}>
                                            <thead>
                                                <tr>
                                                    <th>Registration Number</th>
                                                    <th>Route Code</th>
                                                    <th>Route Name</th>
                                                    <th>Supplied Quantity</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {csvData.map(item => (
                                                    <tr>
                                                        <td>{item.customerName}</td>
                                                        <td>{item.collectionPointCode}</td>
                                                        <td>{item.collectionPointName}</td>
                                                        <td>{item.suppliedQty}</td>
                                                        <td>{item.cardReadTime}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactHTMLTableToExcel
                                            id="test-table-xls-button"
                                            className="btn btn-primary pull-right ml-2"
                                            table="table-to-xls"
                                            filename="FalconProductCollectionReport"
                                            sheet="tablexls"
                                            buttonText="EXCEL XLS"
                                        />

                                        {/* <ExcelFile fileExtension="xls" filename= "Table" element={<input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                        />}>
                                            <ExcelSheet data={csvData} filename= "Table">
                                                <ExcelColumn label="Registration Number" value="customerName" />
                                                <ExcelColumn label="Route Code" value="collectionPointCode" />
                                                <ExcelColumn label="Route Name" value="collectionPointName" />
                                                <ExcelColumn label="Supplied Quantity" value="suppliedQty" />
                                                <ExcelColumn label="Date" value="cardReadTime" />
                                            </ExcelSheet>

                                        </ExcelFile> */}
                                    </div>

                                    
                                    {/* <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} fieldColumnNames={fieldColumnNames}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} sumTableTotal={sumTableTotal}
                                            fullTotalRow={fullTotalRow}
                                            sumTableData={sumTableData} sumFieldContentRowNames={sumFieldContentRowNames} />
                                    </div> */}
                                </div>
                                
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
